import React from 'react'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { BaseLayout } from '../BaseLayout'

interface ContentOnlyLayoutProps {
  children: React.ReactNode
  isDarkMode?: boolean
}

export const ContentOnlyLayout: React.FC<ContentOnlyLayoutProps> = ({ children, isDarkMode = false }) => {
  return (
    <BaseLayout isDarkMode={isDarkMode}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
    </BaseLayout>
  )
}
